import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { defineStore } from 'pinia'
import useFamilyBookPreload from '@/composables/preLoad/familyBook/useFamilyBookPreload.js'

export const usePreloadStore = defineStore('preloadStore', () => {
  const authStore = useAuthStore()

  const prepareForm = async () => {
    const formStore = useFormStore()

    const {
      arabicFirstName,
      englishFirstName,
      arabicFatherName,
      englishFatherName,
      arabicGrandName,
      englishGrandName,
      arabicFourthName,
      englishFourthName,
      professionId,
      educationLevelId
    } = authStore.individualInfo

    Object.assign(formStore.draft.request, {
      applicantEngFirstName: englishFirstName,
      applicantArbFirstName: arabicFirstName,
      applicantEngFatherName: englishFatherName,
      applicantArbFatherName: arabicFatherName,
      applicantEngThirdName: englishGrandName,
      applicantArbThirdName: arabicGrandName,
      applicantEngFourthName: englishFourthName,
      applicantArbFourthName: arabicFourthName,
      applicantEducationLevelId: educationLevelId,
      applicantProfessionId: professionId
    })
    await useFamilyBookPreload()
  }

  const actions = { prepareForm }

  return { ...actions }
})

export default async function () {
  const requests = []

  await usePreloadStore().prepareForm(requests)
}
